import window from "window-or-global";

import waitForGlobal from "./wait-for-global-PLEASE-AVOID-USING";

export function isRequiredModuleLoaded(module) {
  try {
    window.require(module);
    return true;
  } catch (err) {
    return false;
  }
}

export default function waitForRequiredModule(
  { listener, module, interval = 250 },
  callback
) {
  waitForGlobal(
    {
      listener: `wait-for-required-module ${module}`,
      globalProperty: "require"
    },
    () => {
      if (isRequiredModuleLoaded(module)) {
        callback();
        return;
      }

      const waitForRequiredModuleInterval = setInterval(() => {
        if (process.env.NODE_ENV !== "production") {
          console.info(
            `${listener} is waiting for global module ${module} to be available`
          );
        }

        if (isRequiredModuleLoaded(module)) {
          if (process.env.NODE_ENV !== "production") {
            console.info(`${module} now available!`);
          }

          clearInterval(waitForRequiredModuleInterval);
          callback();
        }
      }, interval);
    }
  );
}
